import { BrowserRouter } from "react-router-dom";

import Router from "./Routes";
import Layout from "./Layout";
import AuthDataProvider from "./AuthDataProvider";

function App() {
  return (
    <BrowserRouter>
      <AuthDataProvider>
        <Layout>
          <Router />
        </Layout>
      </AuthDataProvider>
    </BrowserRouter>
  );
}

export default App;
